export const regex = {
  NUMBER_ONLY: /^\d+$/,
  NUMBER_DECIMAL: /^\d+(\.\d+)?$/
};
